module.exports = "/_next/static/images/staff-pick-badge-3e9a5b31b7b2c1f11ddbe26d3e194807.png";